import React from "react";
import { CircleX } from "lucide-react";
import { useNavigate } from "react-router-dom";

const AccessDenied = () => {
    const navigate = useNavigate();
  return (
    <div className="w-full h-screen flex flex-col justify-center items-center">
      <CircleX size={100} color="#cf0d0d" />
      <div className="text-[25px] font-medium">Access Denied</div>
      <div className="text-slate-500">
        You don't have permission to access this page.
      </div>
      <div className="pt-5">
        <button
          type="button"
          className="text-white btn bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600 hover:border-custom-600 focus:text-white focus:bg-custom-600 focus:border-custom-600 focus:ring focus:ring-custom-100 active:text-white active:bg-custom-600 active:border-custom-600 active:ring active:ring-custom-100 dark:ring-custom-400/20"
          onClick={() => navigate("/login")}
        >
          Go Back to Login
        </button>
      </div>
    </div>
  );
};

export default AccessDenied;
